import { SimpleGrid, Flex, Spacer, Text } from '@chakra-ui/react';
import React from 'react';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';

import { CoreBorrowingBaseInsightsGqlDataGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import { PortfolioGridItem } from '../shared/PortfolioGridItem';
import { PortfolioSummaryBorrowingBaseSummary } from './PortfolioSummaryBorrowingBaseSummary';
import { Typography } from '~/packages/common-frontend/components/Typography';

type PortfolioSummaryChartCardsProps = {
  selectedBarData: CoreBorrowingBaseInsightsGqlDataGQLType;
  creditFacilityId: string;
};
export const PortfolioSummaryChartCards = ({
  selectedBarData,
  creditFacilityId,
}: PortfolioSummaryChartCardsProps) => {
  const {
    reportingDate,
    fileVersion,
    currentPrincipalBalance,
    commitmentAmount,
    totalFacilityUtilization,
  } = selectedBarData;
  return (
    <>
      <Flex direction="column">
        <Flex>
          <Typography variant="section-subtitle">Utilization</Typography>
          <Spacer />
          <Text fontSize="sm" fontWeight={500}>
            Reporting Date:{' '}
            {commonDate.fullDateStrToHumanDateString(reportingDate)}
          </Text>
        </Flex>
        <SimpleGrid columns={{ sm: 2, md: 3, lg: 3, xl: 3 }} gap="1.5rem">
          <PortfolioGridItem
            label="Principal Balance"
            value={commonUtils.numberToCurrencyWithSymbol({
              number: currentPrincipalBalance,
            })}
          />
          <PortfolioGridItem
            label="Commitment"
            value={commonUtils.numberToCurrencyWithSymbol({
              number: commitmentAmount,
            })}
          />
          <PortfolioGridItem
            label="Total Facility Utilization"
            value={
              totalFacilityUtilization
                ? commonUtils.numberToFormattedString(
                    totalFacilityUtilization,
                    'percentage',
                    false,
                  )
                : '-'
            }
          />
        </SimpleGrid>
      </Flex>
      <PortfolioSummaryBorrowingBaseSummary
        creditFacilityId={creditFacilityId}
        reportingDate={reportingDate}
        fileVersion={fileVersion}
      />
    </>
  );
};
